var orderRejectionTypes = [
    "Mismatch in Scheme Name",
    "Mismatch in Client Name",
    "Mismatch in PAN",
    "Mismatch in Bank Name",
    "Mismatch in Cheque Number",
    "Mismatch in Cheque Date",
    "Others",
];
export { orderRejectionTypes };
